import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasDynamicComponentsService } from '@cikrf/gas-utils/services';

import {
  GasIconDefinitionsComponent,
} from '../../utils/gas-icons/definitions/gas-icon-definitions.component';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasNotifyModule } from '../../notifications/gas-notify/gas-notify.module';
import { GasNotifyWrapperComponent } from '../../notifications/gas-notify/wrapper/gas-notify-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    GasIconsModule,
    GasNotifyModule,
  ],
})
export class GasBaseModule {
  constructor(
    private gasDynamicComponentsService: GasDynamicComponentsService,
  ) {
    /** Чистим старые */
    document.querySelectorAll('gas-icon-definitions').forEach((x: HTMLElement) => x.remove());
    document.querySelector('gas-notify-wrapper')?.remove();

    this.gasDynamicComponentsService.createComponent(GasIconDefinitionsComponent);
    this.gasDynamicComponentsService.createComponent(GasNotifyWrapperComponent);
  }
}
